import styled, { createGlobalStyle, keyframes, css } from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import { theme } from '../../styles';

const slideIn = keyframes`
  from {
    right: -1%; 
  }
  to {
    right: 0;
  }
`;

const slideOut = keyframes`
  from {
    right: 0;
  }
  to {
    right: -100%; 
  }
`;

export const FlyoutDrawerComponent = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${({ isOpen }) => (isOpen ? `1000` : `-1`)};
  background: ${({ isOpen }) => (isOpen ? `rgba(28, 28, 28, 0.56)` : `rgba(28, 28, 28, 0)`)};
  transition: background-color 0.3s;
`;

export const StyledModalHeader = styled.div`
  .text-wrapper {
    padding-right: ${toRem(8)};
    width: 100%;
  }

  .header-container {
    display: flex;
    align-items: center;
    .header-icon {
      height: ${toRem(24)};
      width: ${toRem(24)};
      font-size: ${toRem(24)};
      display: flex;
      align-items: center;
      margin-right: ${toRem(8)};
      font-weight: initial;
      &.t-program-logo-alt-cn-color,
      &.t-program-logo-alt-color {
        height: auto;
        width: auto;
        font-size: 4.082rem;
        margin-bottom: ${toRem(-25)};
        right: ${toRem(12)};
        top: ${toRem(4)};
      }
      &.icon-success::before {
        color: ${theme.colors['alert-30']};
      }
    }
  }
`;

export const StyledModalContainer = styled.div`
  min-height: 200px;
  padding-bottom: 0;
`;

export const StyledContainer = styled.div<{ isOpen: boolean; hasBeenOpened: boolean; isAccountFlyout?: boolean }>`
  position: fixed;
  height: 100vh;
  top: 0;
  right: -100%;
  background-color: ${baseVariables.color['base20']};
  z-index: 999;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  .height-100 {
    height: 100%;
  }

  ${props =>
    props.isOpen &&
    css`
      animation: ${slideIn} 0.3s forwards;
    `}

  ${props =>
    !props.isOpen &&
    props.hasBeenOpened &&
    css`
      animation: ${slideOut} 0.3s forwards;
    `}

  &[aria-hidden="true"] {
    .m-button-m,
    .m-button,
    .m-link-action,
    .close-icon,
    .checkbox {
      display: none;
    }
  }

  width: 100vw;
  @media ${baseVariables.mediaQuery.sm} {
    width: ${props => (props.isAccountFlyout ? toRem(440) : toRem(364))};
  }
  @media ${baseVariables.mediaQuery.lg} {
    width: ${toRem(440)};
  }

  .header-container {
    min-height: 88px;
    padding: 0px 24px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
    background: rgba(28, 28, 28, 0);
    overflow: hidden;
    .text-wrapper {
      padding-right: ${toRem(8)};
      width: 100%;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 125%;
      text-overflow: ellipsis;
      overflow: hidden;
      color: ${theme.colors['base-10']};
    }
    @media ${baseVariables.mediaQuery.sm} {
      padding: 0px 32px;
    }
    .header-icon {
      height: ${toRem(32)};
      width: ${toRem(32)};
      font-size: ${toRem(32)};
      display: flex;
      align-items: center;
      margin-right: ${toRem(8)};
      font-weight: initial;
      &.t-program-logo-alt-cn-color,
      &.t-program-logo-alt-color {
        height: auto;
        width: auto;
        font-size: 4.082rem;
        margin-bottom: ${toRem(-25)};
        top: ${toRem(4)};
        right: ${toRem(20)};
      }
      &.icon-success::before {
        color: ${theme.colors['alert-30']};
      }
    }
    .close-icon {
      top: ${toRem(42)};
      right: ${toRem(42)};
      max-height: ${toRem(32)};
      width: ${toRem(32)};
      border-radius: ${toRem(4)};
      background-color: ${baseVariables.color['neutral20']};
      text-align: center;
      padding: ${toRem(4)};
      margin-left: auto;
    }

    .icon-clear::before {
      height: ${toRem(24)};
      width: ${toRem(24)};
    }
  }
  .content-wrapper {
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const GlobalStyle = createGlobalStyle`
  body.modal-open {
    overflow: hidden !important;
  }
`;
